import {obterDados} from '../utils/Session'
export const isAuthenticated = () => {
  console.log("verificando se está logado");
  return obterDados() && obterDados().token !== null;
}